import { render, staticRenderFns } from "./BrowseScreens.vue?vue&type=template&id=45cba512&scoped=true"
import script from "./BrowseScreens.vue?vue&type=script&lang=js"
export * from "./BrowseScreens.vue?vue&type=script&lang=js"
import style0 from "./BrowseScreens.vue?vue&type=style&index=0&id=45cba512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cba512",
  null
  
)

export default component.exports